import debounce from 'lodash.debounce';

class scrollListener {
  constructor() {
    this.searchbar = document.querySelector('.hdr-searchbar');
    this.searchbarTrigger = document.querySelector('.hdr-searchbar-trigger');
    this.scrollTop = document.querySelector('.scroll-top');

    if (this.searchbarTrigger) {
      this.searchbarTriggerPos = 0;
      //this.getTriggerPosition = this.getTriggerPosition.bind(this);
      this.getTriggerPosition();
      this.onScroll();
    }

    this.addEventListeners();
  }

  /* tests for passive event listener support */
  testPassive() {
    this.supportsPassive = false;
    try {
      const opts = Object.defineProperty({}, 'passive', {
        get: () => (this.supportsPassive = true),
      });
      window.addEventListener('test', null, opts);
    } catch (e) {
      /**/
    }
  }

  addEventListeners() {
    const debouncedResize = debounce(() => this.getTriggerPosition, 400);
    if (this.searchbarTrigger) {
      window.addEventListener('resize', debouncedResize);
    }
    window.addEventListener(
      'scroll',
      this.onScroll,
      this.supportsPassive ? { passive: true } : false,
    );
  }

  getTriggerPosition() {
    const documentScrollTop = (window.pageYOffset || document.documentElement.scrollTop)  - (document.documentElement.clientTop || 0);
    this.searchbarTriggerPos = documentScrollTop + this.searchbarTrigger.getBoundingClientRect().top;
  }

  onScroll = () => {
    if (this.searchbarTrigger) {
      if (window.scrollY > this.searchbarTriggerPos) {
        document.documentElement.classList.add('fixed-hdr-sb');
      } else {
        document.documentElement.classList.remove('fixed-hdr-sb');
      }
    }

    if (this.scrollTop) {
      if (window.scrollY > window.innerHeight * 0.4) {
        this.scrollTop.classList.add('is-visible');
      } else {
        this.scrollTop.classList.remove('is-visible');
      }
    }
  };
}

new scrollListener();



// WEBPACK FOOTER //
// ./src/js/scroll-events.js